import { createElement } from "react";

export const HEADING_TYPES = {
	h1: "h1",
	h2: "h2",
	h3: "h3",
	h4: "h4",
	p: "p",
};

const Heading = ({
	type = HEADING_TYPES.h1,
	content,
	className,
	modifier,
	ariaLabel,
}) => {
	const mainClass = "help-heading";
	const classList = [mainClass];
	if (className) classList.push(className);
	if (modifier) classList.push(`${mainClass}--${modifier}`);
	const fullClass = classList.join(" ");

	return createElement(type, {
		className: fullClass,
		"aria-label": ariaLabel && ariaLabel !== content ? ariaLabel : null,
		dangerouslySetInnerHTML: { __html: content },
	});
};

export default Heading;
